import { Children, CSSProperties, PropsWithChildren } from 'react'
import classNames from 'classnames'
import useWindowSize from 'hooks/useWindowSize.tsx'
import { VerticalSliderProps } from './types.ts'
import styles from './VerticalSlider.module.scss'

const VerticalSlider = ({ children, duration = 12500, reverse = false }: PropsWithChildren<VerticalSliderProps>) => {
  // Window size
  const { isMobile } = useWindowSize()

  const items = Children.map(children, (child) => <div className={styles['vertical-slider-item']}>{child}</div>)

  return (
    <div
      className={classNames(styles['vertical-slider'], {
        [styles.reverse]: reverse,
        [styles['pause-on-hover']]: !isMobile
      })}
      style={{ '--vertical-slider-duration': `${duration}ms` } as CSSProperties}
    >
      <div className={styles.track}>
        <div className={styles.group}>{items}</div>
        {/* The loop is seamless because the track scrolls exactly one group before repeating */}
        <div className={styles.group} aria-hidden="true">
          {items}
        </div>
      </div>
    </div>
  )
}

export default VerticalSlider
